<template>
  <div>
    <Header />

    <div class="content-web container mt-5">
      <div class="table-box list-grid mb-5">
        <div class="row ml-0 mr-0">
          <div class="title col-lg-4 col-md-4 col-sm-4 col-xs-12">
            <h6>QUẢN LÝ BANNER</h6>
          </div>
          <div class="col-lg-8 col-md-8 col-sm-8 col-xs-12 d-flex justify-content-end pl-2">
            <b-form-select
              class="mr-2"
              style="width: 140px;"
              v-model="selectedFilter"
              :options="filterOptions"
              @input="filterByStatus"
            ></b-form-select>

            <button type="button" class="btn btn-info mr-2" @click="showAddBanner = true">
              <i class="fa fa-plus mr-1"></i>Thêm Banner
            </button>
          </div>
        </div>

        <div class="content-table">
          <table class="table table-responsive">
            <thead>
              <tr>
                <th style="width:15%">LỰU CHỌN BANNER</th>
                <th style="width:15%">KÍCH HOẠT</th>
                <th style="width:15%">VỊ TRÍ</th>
                <th style="width:60%">TÊN FILE</th>
                <th style="width:15%">HÀNH ĐỘNG</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="items in dataManageBanner" v-bind:key="items.id">
                <td>
                  <input
                    type="checkbox"
                    id="checkbox"
                    v-model="items.active"
                    v-on:click="changeStatus(items)"
                  />
                </td>
                <td>{{ items.active }}</td>
                <td>{{ items.position }}</td>
                <td>{{ items.fileName }}</td>
                <td>
                  <button
                    v-on:click="moveIdtoModel(items.id)"
                    data-toggle="modal"
                    data-target="#deleteManageBannerForm"
                    class="btn btn-danger"
                  >
                    <i class="fa fa-trash"></i>
                  </button>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>

    <b-modal
      v-model="showAddBanner"
      id="modal-prevent-closing"
      ref="modal"
      title="Thêm banner mới"
      @show="showAddForm"
    >
      <form>
        <label class="required">Lựu chọn vị trí:</label>
        <b-form-select class="mb-2" v-model="selectedPositionBanner" :options="options"></b-form-select>
        <input class="form-control input-name mb-2" v-model="textUrlBanner" placeholder="URL" />
        <vue-dropzone
          class="mb-2"
          id="slideshow"
          :options="imageUploadOptions"
          :useCustomSlot="true"
          ref="uploadFileDropzone"
          @vdropzone-success="onUploadSlideShowSuccess"
          @vdropzone-removed-file="onRemoveSlideShow"
        >
          <div class="dropzone-custom-content">
            <h4 class="dropzone-custom-title">Kéo thả hình ảnh hoặc chọn từ trình duyệt.</h4>
          </div>
        </vue-dropzone>
      </form>
      <template v-slot:modal-footer>
        <button type="button" class="btn btn-secondary" @click="showAddBanner = false">Hủy</button>
        <button v-on:click="addManageBanner" class="btn btn-primary" data-dismiss="modal">Lưu</button>
      </template>
    </b-modal>

    <div
      class="modal fade"
      id="deleteManageBannerForm"
      tabindex="-2"
      role="dialog"
      aria-labelledby="exampleModalLabel"
      aria-hidden="true"
    >
      <div class="modal-dialog" role="document">
        <div class="modal-content">
          <div class="modal-header"></div>
          <div class="modal-body">Bạn có chắc muốn xóa banner này?</div>
          <div class="modal-footer">
            <button type="button" class="btn btn-secondary" data-dismiss="modal">Hủy</button>
            <button
              v-on:click="deleteManageBanner"
              type="button"
              class="btn sku-btn"
              data-dismiss="modal"
            >Đồng ý</button>
          </div>
        </div>
      </div>
    </div>
    <Footer />
  </div>
</template>

<script>
import "bootstrap/dist/css/bootstrap.css";
import "bootstrap-vue/dist/bootstrap-vue.css";
import Header from "@/components/common/Header";
import Footer from "@/components/common/Footer";
import vue2Dropzone from "vue2-dropzone";
import "vue2-dropzone/dist/vue2Dropzone.min.css";
import axios from "axios";
import * as CONFIG from "../../config/index";
import helper from "../../common/helper";
import { BPagination } from "bootstrap-vue";
import Vue from "vue";

export default {
  name: "ManageBanner",
  components: {
    Header,
    Footer,
    vueDropzone: vue2Dropzone,
    "b-pagination": BPagination
  },
  data() {
    return {
      page: 1,
      perPage: 10,
      totalPages: 0,
      totalData: 0,
      idManageBanner: null,
      dataManageBanner: [],
      manageBannerVO: {
        position: null,
        url: null,
        active: true,
        imageId: null
      },
      checkBoxActive: null,
      statusManageBanner: true,
      textUrlBanner: null,

      selectedPositionBanner: "Bottom",
      options: [
        {
          value: "Bottom",
          text: "Dưới"
        },
        {
          value: "Left",
          text: "Trái"
        },
        {
          value: "Right",
          text: "Phải"
        },
        {
          value: "Top",
          text: "Trên"
        }
      ],
      selectedFilter: "null",
      filterOptions: [
        {
          value: "null",
          text: "Mặc định"
        },
        {
          value: "true",
          text: "Kích hoạt"
        },
        {
          value: "false",
          text: "Vô hiệu hóa"
        }
      ],
      imageUploadOptions: {
        url: `${CONFIG.API_URL}/image/upload?type=banner`,
        thumbnailWidth: 120,
        addRemoveLinks: true,
        acceptedFiles: "image/*",
        headers: this.getAuthHeader(),
        maxFiles: 1
      },
      showAddBanner: false
    };
  },
  watch: {
    pageIndex: {
      immediate: false,
      handler(newVal, oldVal) {
        this.getAll();
      }
    },
    pageFilterByStatus: {
      immediate: false,
      handler(newVal, oldVal) {
        this.filterByStatus(event);
      }
    }
  },
  mounted() {
    this.getStatus;
    this.getAll();
  },
  methods: {
    getAll: function() {
      this.axios
        .get(
          `${CONFIG.API_URL}/manageBanner/listManageBanner?pageIndex=` +
            this.page +
            `&pageSize=` +
            this.perPage
        )
        .then(resBanner => {
          this.dataManageBanner = resBanner.data.data.items;

          this.totalPages = Math.ceil(
            resBanner.data.data.totals / this.perPage
          );
          this.totalData = resBanner.data.data.totals;
        })
        .catch(e => {});
    },
    pageChange: function(pageIndex) {
      this.page = pageIndex;
      if (this.selectedFilter == "null") {
        this.getAll();
      } else {
        this.getDataOption();
      }
    },
    changeStatus: function(items) {
      // this.idManageBanner = item.id;
      this.manageBannerVO.id = items.id;
      this.manageBannerVO.active = !items.active;
      this.manageBannerVO.url = items.url;
      this.manageBannerVO.position = items.position;
      this.axios
        .put(`${CONFIG.API_URL}/manageBanner`, this.manageBannerVO)
        .then(res => {
          helper.successMsg("Cập nhật thành công");
        });
    },
    moveIdtoModel: function(id) {
      this.idManageBanner = id;
    },

    filterByStatus: function() {
      this.page = 1;
      if (this.selectedFilter == "null") {
        this.getAll();
      } else {
        this.getDataOption();
      }
    },
    getDataOption: function() {
      this.axios
        .get(
          `${CONFIG.API_URL}/manageBanner/filterBannerByStatus?active=` +
            this.selectedFilter +
            `&pageIndex=` +
            this.page +
            `&pageSize=` +
            this.perPage
        )
        .then(resBannerFilter => {
          this.dataManageBanner = resBannerFilter.data.data.items;
          this.totalPages = Math.ceil(
            resBannerFilter.data.data.totals / this.perPage
          );
          this.totalData = resBannerFilter.data.data.totals;
        });
    },
    deleteManageBanner: function(event) {
      this.axios
        .delete(`${CONFIG.API_URL}/manageBanner?id=` + this.idManageBanner)
        .then(resBanner => {
          helper.successMsg("Xóa banner thành công");
          this.getAll();
        })
        .catch(e => {
          helper.errMsg("Xóa banner thất bại");
        });
    },
    addManageBanner: function(event) {
      if (!this.manageBannerVO || !this.manageBannerVO.imageId) {
        helper.errMsg("Chưa chọn banner!");
        return;
      }
      this.manageBannerVO.position = this.selectedPositionBanner;
      this.manageBannerVO.url = this.textUrlBanner;
      this.axios
        .post(`${CONFIG.API_URL}/manageBanner`, this.manageBannerVO)
        .then(resNewBanner => {
          if (resNewBanner.data.message[0].code == "duplicate") {
            helper.errMsg("Banner đã tồn tại!");
          } else {
            helper.successMsg("Thêm banser thành công.");
            this.getAll();
          }
          this.showAddBanner = false;
        })
        .catch(e => {
          helper.errMsg("Thêm banner thất bại");
        });
    },
    onUploadSlideShowSuccess: function(file, response) {
      const uploadedFile = response && response[0];
      if (uploadedFile) {
        const id = uploadedFile.id;
        this.manageBannerVO.imageId = id;
      }
    },
    onRemoveSlideShow: function(file, error, xhr) {
      this.manageBannerVO.imageId = "";
    },
    getAuthHeader() {
      let token = Vue.$cookies.get("accessToken");
      return {
        Authorization: `Bearer ${token}`
      };
    },
    showAddForm() {
      this.selectedPositionBanner = "Bottom";
      this.textUrlBanner = null;
      // this.$refs.uploadFileDropzone.removeAllFiles();
    }
  }
};
</script>

<style scoped>
@import "../../assets/css/table_customs.css";
</style>


// WEBPACK FOOTER //
// src/components/pages/ManageBanner.vue